module.exports = __webpack_public_path__ + "79de2276f8cf31775f7f8efda296b486.pdf";